<div *ngIf="true">

  <!-- Breadcrumb -->
  <app-campaign-3-breadcrumb #breadcrumbComponent [arrayBreadcrumbs]="breadcrumbs"
  homeLink=""  (onClickBreadcrumb)="breadcrumbClicked($event)" >
 </app-campaign-3-breadcrumb>

  <br />

  <!-- Toolbar delle fasi -->
  <kv-phases-toolbar
    [phases]="auditPhases"
    (onClickPhase)="phaseClicked($event)">
  </kv-phases-toolbar>


  <div  >

    <div class="infoBaseContainer" [ngClass]="{'formHidden': show.infoBase == false }">
      <app-audit-rule-base
        #infoBaseComponent
        [language]="language"
        [dateFormat]="dateFormat"
        [schemaMode]="schemaMode"
        [ui_mode]="uiModes.infoBase"
        [readOnly]="readOnly || isChallenge"
        (formSchemaChanged)="onFormSchemaChanged($event)"
        (enableConfirmButton)="onConfirmButtonEnabled($event)"
        [clusterOption]="clusterOption"
        [clusterOptionActive]="clusterOptionActive"
        [acmList]="acmList"
        [challengeList]="challengeList"
        [challengeListFull]="challengeListFull"
        [dateRangeForm]="dateRangeForm"
        [auditRuleObject]="auditRuleObject"
        [actionsRulesTypeCombo]="actionsRulesTypeCombo"
        [actionsRulesType]="actionsRulesType"
        [listSchemas]="listSchemas"
        [listTemplates]="listTemplates"
        >
      </app-audit-rule-base>
    </div>

    <!-- FASE 2 - Condition -->
    <div class="conditionContainer" [ngClass]="{'formHidden': show.condition == false }">
      <app-audit-condition
        #conditionComponent
        [language]="language"
        [dateFormat]="dateFormat"
        [ui_mode]="uiModes.action"
        [readOnly]="readOnly"
        [clusterOption]="clusterOption"
        [clusterOptionActive]="clusterOptionActive"
        [touchpointOption]="touchpointOption"
        [sourceSystemOption]="sourceSystemOption"
        [acmList]="acmList"
        [acmListFull]="acmListFull"
        [auditRuleObject]="auditRuleObject"
        [listReasons]="listReasons"
        (formSchemaChanged)="onFormSchemaChanged($event)"
        [readOnly]="readOnly"
        [ruleId]="ruleId"
        [listReasonsFiltered]="listReasonsFiltered"
        (conditionObjectChanged)="onConditionObjectChanged($event)"
        [listReasonsFull]="listReasonsFull"
        [isChallenge]="isChallenge">
        >
      </app-audit-condition>
    </div>

    <!-- FASE 3 - Tipi di azione -->
    <div class="actionContainer" [ngClass]="{'formHidden': show.action == false }">
      <app-audit-action
        #actionComponent
        [language]="language"
        [dateFormat]="dateFormat"
        [ui_mode]="uiModes.action"
        [readOnly]="readOnly"
        [clusterOption]="clusterOption"
        [clusterOptionActive]="clusterOptionActive"
        [acmList]="acmList"
        [acmListFull]="acmListFull"
        [auditRuleObject]="auditRuleObject"
        [listReasons]="listReasons"
        (formSchemaChanged)="onFormSchemaChanged($event)"
        [readOnly]="readOnly"
        [ruleId]="ruleId"
        [listReasonsFiltered]="listReasonsFiltered"
        [listReasonsFull]="listReasonsFull"
        (conditionObjectChanged)="onConditionObjectChanged($event)"
        [isChallenge]="isChallenge">
      </app-audit-action>
    </div>

    <div class="footerContainer">
      <br />
      <!-- Info campi obbligatori -->
      <div class="infoRequiredContainer">
        {{ 'audit.fields_marked' | translate }}
        <span class="asterix">*</span>
        {{ 'audit.fields_required' | translate }}
      </div>

      <!-- Bottoni Indietro e Conferma -->
      <div class="buttonsContainer">
        <button pButton *ngIf="currentPhaseIndex>0"
          (click)="onClickBackBtn()" icon="fa fa-chevron-left"
          iconPos="left" type="button" class="k-generic-btn footer-btn"
          label="{{'audit.backBtn' | translate}}">
        </button>
        <button pButton data-testid="confirmButton" type="submit" *ngIf="!isChallenge"
          (click)="onClickSaveBtn()" icon="fa fa-chevron-right" iconPos="right" class="k-generic-btn footer-btn"
          label="{{'audit.saveBtn' | translate}}">
        </button>
        <button pButton (click)="onClickFwdBtn()"  *ngIf="currentPhaseIndex<2"
          icon="fa fa-chevron-right" iconPos="right" type="button" class="k-generic-btn footer-btn"
           label="{{'audit.forwardBtn' | translate}}">
        </button>
        <button *ngIf="allowSaveActionTemplate" class="star-button">
          <i class="pi pi-star" [ngClass]="{'pi-star-favourite': favouriteAction}" (click)="onSaveFavourite()"></i>
        </button>
      </div>

      <div class="clear_fix"></div>

      <br />
    </div>
  </div>

  <div *ngIf="showSuccessPopup" class="success-popup">
    {{ 'audit.rule_saved_success' | translate }}
  </div>
  <div *ngIf="showSuccessDeletePopup" class="success-popup">
    {{ 'audit.rule_deleted_success' | translate }}
  </div>



// WEBPACK FOOTER //
// ./src/app/views/audit/rules/add-rule/add-rule.component.html